import ReportController from './report.controller';

export default class PaxReportController extends ReportController
{
	get endpoint() {
		return 'pax';
	}

	get title() {
		return 'Pax Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/pax.report.controller.js
 **/